// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"TextWithMediaSmall_imageWrapper___iAPb","contentWrapper":"TextWithMediaSmall_contentWrapper__Yqgyn"};